import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const FIELDS = [
  ["legal_name", "Ragione sociale"], ["trade_name", "Nome commerciale"],
  ["vat_number", "Partita IVA"], ["legal_form", "Forma giuridica"],
  ["ateco_primary", "Codice ATECO"], ["city", "Comune"],
  ["region", "Regione"], ["revenue_band", "Fascia fatturato"],
];

export default function Azienda() {
  const [company, setCompany] = useState(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    api.get("/companies/mine").then(r => setCompany(r.data?.company_id ? r.data : null))
      .catch(() => {}).finally(() => setLoaded(true));
  }, []);
  if (!loaded) return <div className="max-w-4xl mx-auto px-4 py-20 text-center">Caricamento…</div>;
  if (!company) return (
    <div className="max-w-3xl mx-auto px-4 py-20 text-center" data-testid="azienda-empty">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">La tua azienda</h1>
      <p className="text-[#524F5E] mt-3">Non hai ancora creato la tua azienda. Il Business Check ti guida: pochi dati e ottieni score, benchmark e report.</p>
      <Link to="/business-check" className="ic-btn-primary inline-block mt-6" data-testid="azienda-create-cta">Crea la tua azienda</Link>
    </div>
  );
  return (
    <div className="max-w-4xl mx-auto px-4 py-12" data-testid="azienda-page">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">La tua azienda</h1>
      <p className="text-[#524F5E] mt-2">Questi dati restano privati: visibili solo a te.</p>
      <div className="ic-card p-6 mt-8">
        <div className="grid md:grid-cols-2 gap-4">
          {FIELDS.filter(([k]) => company[k]).map(([k, l]) => (
            <div key={k} data-testid={`azienda-${k}`}>
              <p className="text-xs uppercase tracking-widest text-[#7A7788]">{l}</p>
              <p className="font-semibold mt-0.5">{company[k]}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap gap-3 mt-6">
        <Link to="/report" className="ic-btn-primary" data-testid="azienda-report-cta">Vai al Report</Link>
        <Link to="/business-check" className="ic-btn-ghost" data-testid="azienda-update-cta">Aggiorna i dati</Link>
      </div>
    </div>
  );
}
